import type { HtmlAttributes } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Contingency } from '#~/room/components/common/index.js';
import type { ContingencyProps } from '#~/room/components/common/index.js';
import { Icon } from '#~/video/image/components/icon/index.js';

/** @internal */
const Inner = ({ className, ...props }: Omit<ContingencyProps, 'icon'>): ReactElement => (
  <Contingency className={twMerge('m-16', className)} icon={Icon} {...props} />
);

/** `<Empty>` component. */
export const Empty = (props: HtmlAttributes): ReactElement => (
  <Inner {...props} message='A video source must be added to begin.' />
);

/** `<Unsupported>` component. */
export const Unsupported = (props: HtmlAttributes): ReactElement => (
  <Inner
    {...props}
    message="The video source you've selected doesn't support this functionality."
  />
);
